import { useNavigate } from 'react-router-dom';
import styles from './hotlinks.module.scss';
import { Block, Grid } from '@sanlam-glacier/app-common/modules/grid';
import { HotLinksProps } from 'modules/dashboard/types/widgets/widget.interfaces';
import { Icon } from '@sanlam-glacier/app-common/components';

export const HotLinksWidget = ({ links }: HotLinksProps) => {
  const navigate = useNavigate();
  const testComponentName = 'shortcutsWidget';

  return (
    <Grid className={styles.hotlinksContainer} gap={3} dense={true} data-testid={testComponentName}>
      {links.map((link, index) => (
        <Block key={index} xs={12} sm={6} md={4} lg={3} className={styles.hotlinkBlock}>
          <div className={styles.hotlinkCard} onClick={() => navigate(link.path)}>
            <div className={styles.hotlinkIcon}>
              <Icon
                data-testid={testComponentName + link.icon}
                className={styles.icon}
                icon={link.icon}
              />
            </div>
            <div className={styles.hotlinkLabelContainer}>
              <div className={styles.hotlinkLabel}>{link.label}</div>
            </div>
          </div>
        </Block>
      ))}
    </Grid>
  );
};

export default HotLinksWidget;
